import React from 'react';
import ProductCatalogPanel from '@/tiktok-platform/modules/products/components/ProductCatalogPanel';

export default function ProductListPage() {
  return <ProductCatalogPanel mode="catalog" showStatusTabs />;
}
